import { Reveal } from "@/lib/motion";
import { TESTIMONIALS } from "@/data/site";

export const Testimonials = () => (
  <section data-testid="testimonials" className="section-pad bg-white">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#999999] mb-6 font-mono">In their words</p>
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure className="h-full flex flex-col border-t border-[#111111] pt-8">
              <blockquote className="font-serif text-2xl md:text-3xl leading-[1.35] text-[#111111]">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-[#E0E0E0]">
                <p className="font-semibold text-[#111111]">{t.name}</p>
                <p className="text-sm text-[#666666]">{t.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
